import React from 'react';
import Checkbox from '../Checkbox/Checkbox';
import IconWrenchScreedriver from '../../icons/icon-wrench-screwdriver.svg';
import classNames from 'classnames';
import { Loader } from 'react-bootstrap-typeahead';
import RadioGroup from '../AriaRadio/RadioGroup';
import Radio from '../AriaRadio/Radio';
import InfoModal from '../InfoModal/InfoModal';
import InstallationIcon from '../../../shared/icons/icon-wrench-screwdriver.svg';
import HaulawayIcon from '../../../shared/icons/icon-haul-away.svg';
import MarkdownTableRenderer from '../MarkdownRenderers/MarkdownTableRenderer';
import CustomReactMarkdown from '../MarkdownRenderers/CustomReactMarkdown';

const ExternalAddOns = ({ externalAddOns, updateAddOnSelection, inFlight }) => {

    const {
        informationMessage,
        addOns: {
            ids = []
        }
    } = externalAddOns

    if (inFlight) {
        return (
            <div className='externalAddOns__addons-list-container'>
                <Loader showLoader={true} />
            </div>
        )
    }

    if (ids.length === 0) {
        return null;
    }

    const getAddonModal = function (modalInfo, Icon) {

        const message = modalInfo.modalBody;
        const tableContent = modalInfo.tableContent;

        const MessageComponent = (
            <>
                <CustomReactMarkdown source={message} />
                {
                    tableContent && (
                        <MarkdownTableRenderer markdown={tableContent} className='addon'/>
                    )
                }
            </>
        )
        
        return(
            <InfoModal
                styleFlag="extAddOn"
                message={MessageComponent}
                contentLabel={modalInfo.modalTitle}
                subheader={modalInfo.modalSubtitle}
                header={modalInfo.modalTitle}
                headerIcon={<Icon />}
                >
                <span>{modalInfo.modalContentLabel}</span>
            </InfoModal>
        )
    }

    const getRadioFields = function () {
        const {
            addOns: {
                groupedByFieldTypes: {
                    radio: radiofields = {}
                }
            },
            addOns
        } = externalAddOns;

        const radioGroups = Object.keys(radiofields);

        return (
            radioGroups.map((radioGroup) => {
                const selectedValue = radiofields[radioGroup].find((addOnId) => addOns[addOnId].selected);
                return (
                    <RadioGroup
                    label=''
                    showLabel={false}
                    onChange={(value) => value && updateAddOnSelection(value, true)}
                    name={`externalAddOn-${radioGroup}`}
                    key={radioGroup}
                    aria-label={radioGroup}
                    activeValue={selectedValue}
                >
                    {
                        radiofields[radioGroup].map((addOnId) => {
                            const {
                                externalAddOnId,
                                externalAddOnPrice,
                                externalAddOnDisplayPrice,
                                selected,
                                disabled,
                                externalAddOnModalInfo,
                                interDependencyRules
                            } = addOns[addOnId];

                            const price = externalAddOnDisplayPrice || externalAddOnPrice;
            
                            const rowClassName = classNames({
                                "externalAddOns__addons-row": true,
                                "externalAddOns__addons-row--disabled": disabled
                            });
                            return (
                                <div key={externalAddOnId} className='externalAddOns__addons-list-item'>
                                <Radio
                                    key={externalAddOnId} 
                                    value={externalAddOnId}
                                    disabled={disabled}
                                    className={rowClassName}
                                    theme='addOn'
                                    field={{
                                        id: externalAddOnId,
                                        selected: selected,
                                        disabled: disabled,
                                        label: ''
                                    }}>
                                    <div className='externalAddons__addons-row-container'>
                                        <span className='externalAddOns__addons-list-item-label'>{interDependencyRules?.overrides?.displayText}</span>
                                        <span className='externalAddOns__addons-list-item-price'>{`$${price}`}</span>
                                    </div>
                                </Radio>
                                <div className='externalAddons__addons-modal-container'>
                                {externalAddOnModalInfo && getAddonModal(externalAddOnModalInfo, InstallationIcon)}
                                </div>
                                </div>
                            )
                        })}
                </RadioGroup>
                )
            })
        )
    }

    const getCheckboxFields = function () {
        const {
            addOns: {
                groupedByFieldTypes: {
                    checkbox: checkboxFields = {}
                }
            },
            addOns
        } = externalAddOns;

        const checkBoxGroups = Object.keys(checkboxFields);

        return (
            checkBoxGroups.map((checkBoxGroup) => {
                return (
                    checkboxFields[checkBoxGroup].map((addOnId, index) => {
                        const {
                            externalAddOnId,
                            externalAddOnPrice,
                            externalAddOnDisplayPrice,
                            selected,
                            disabled,
                            externalAddOnModalInfo,
                            interDependencyRules
                        } = addOns[addOnId];

                        const price = externalAddOnDisplayPrice || externalAddOnPrice;
            
                        const rowClassName = classNames({
                            "externalAddOns__addons-row": true,
                            "externalAddOns__addons-row--disabled": disabled
                        });

                        const listItemClassName = classNames({
                            "externalAddOns__addons-list-item": true,
                            "externalAddOns__addons-list-item-last": index === checkboxFields[checkBoxGroup].length - 1
                        });
                        return (
                            <div key={externalAddOnId} className={listItemClassName}>
                                <Checkbox
                                    isSelected={selected}
                                    className={rowClassName}
                                    name={`externalAddOn-${externalAddOnId}`}
                                    value={externalAddOnId}
                                    isDisabled={disabled}
                                    onChange={(selected) => updateAddOnSelection(externalAddOnId, selected)}>
                                    <div className='externalAddons__addons-row-container'>
                                        <span className='externalAddOns__addons-list-item-label'>{interDependencyRules?.overrides?.displayText}</span>
                                        <span className='externalAddOns__addons-list-item-price'>{`$${price}`}</span>
                                    </div>
                                    {externalAddOnModalInfo && getAddonModal(externalAddOnModalInfo, HaulawayIcon)}
                                </Checkbox>                        
                            </div>
                        )
                    })
                )
            })
        )
    }

    return (
        <div className='externalAddOns__addons-list-container'>
            <div className='externalAddOns__addons-list-header-container'>
                <div className='externalAddOns__addons-list-header-icon'>
                    <IconWrenchScreedriver />
                </div>
                <div className="externalAddOns__addons-list-header-text">Add-On Services</div>
            </div>

            <div className='externalAddOns__addons-list'>
                {
                    informationMessage ? (
                        <div className='externalAddOns__addons-information-message'>{informationMessage}</div>
                    ) : (
                        <>
                            {
                                getRadioFields()
                            }
                            {
                                getCheckboxFields()
                            }
                        </>
                    )
                }
            </div>
        </div>
    )
}

export default ExternalAddOns;